import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Chart } from 'chart.js';
import 'chartjs-plugin-datalabels';
import { SDGComponent, Result, ResultData, QuestionCategoryGroup, QuestionCategoryType, QuestionType } from '../../_models/index';
import { AlertService, SDGComponentService, ResultService } from '../../_services/index';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { environment } from '../../../environments/environment';
import * as GlobalVariables from '../globals/globals';
import * as jsPDF from 'jspdf';
import * as $ from 'jquery';

var COMP = environment.component.transparency;
var cc = GlobalVariables.ChartConfig;

@Component({
  selector: 'app-transparency-report',
  templateUrl: './transparency-report.component.html',
  styleUrls: ['./transparency-report.component.css']
})
export class TransparencyReportComponent implements OnInit, OnDestroy {

  lang = 1;
  translation: any;
  loading = true;
  subscription1:Subscription;
  subscription2:Subscription;
  chart1 = [];
  chart2 = [];
  chart3 = [];
  chart4 = [];
  chart5 = [];
  chart6 = [];
  subcategories: String[] = [];
  subcat_index : Array<number>=[];

  constructor(private router: Router,
    private sdgComponentService: SDGComponentService,
    private alertService: AlertService,
    private resultService: ResultService,
    private chRef: ChangeDetectorRef
    ) { }

  ngOnInit() {
    $(".header_active").removeClass("header_active")
    $(".integrity-click").addClass("header_active")

    this.lang = GlobalVariables.findTranslationOptionsIndex(window);
    this.translation = GlobalVariables.option_translations[this.lang];

    this.subscription1 = this.sdgComponentService.getAll(COMP).subscribe(data => {
      for (var i=0; i<data.category.length; i++){
        let co = data.category[i].order;
        for(var j=0; j<data.category[i].sub_category.length; j++){
          let sco= data.category[i].sub_category[j].order;
          let sci;
          if (co==1 && sco==1) sci = 0;
          if (co==2 && sco==1) sci = 1;
          if (co==3 && sco==1) sci = 2;
          if (co==3 && sco==2) sci = 3;
          if (co==4 && sco==1) sci = 4;
          if (co==4 && sco==2) sci = 5;
          if (co==5 && sco==1) sci = 6;
          if (co==5 && sco==2) sci = 7;
          if (co==6 && sco==1) sci = 8;
          let xlabel= data.category[i].sub_category[j].name;
          this.subcategories[sci]=xlabel;
          this.subcat_index[data.category[i].sub_category[j].id] = sci;
        }
      }

        this.resultService.getResultData(COMP).subscribe(res => {
          let formulation_policy : Number[]=[];
          let regulatory_policy : Number[]=[];

          let equitable_access_count = [0,0,0,0];
          let equity_access_labels = [this.translation['Adequate'], this.translation['In development'], this.translation['Unknown'], this.translation['Inadequate']];
          let integrity_train_count = [0,0,0,0];
          let integrity_train_labels = [this.translation['yes'], this.translation['no'], this.translation['Unknown'], this.translation['In development']];

          //maintain state of value for each subcategory(9) of Formulation of Policy
          let count_yes_fp = [0,0,0,0,0,0,0,0,0],count_non_empty_fp=[0,0,0,0,0,0,0,0,0], count_3_5_fp=[0,0,0,0,0,0,0,0,0];
           //maintain state of value for each subcategory(9) of Formulation of Policy
           let count_yes_rp = [0,0,0,0,0,0,0,0,0],count_non_empty_rp=[0,0,0,0,0,0,0,0,0], count_3_5_rp=[0,0,0,0,0,0,0,0,0];

          var subcatlabels_small = ['6.1.1', '6.2.1', '6.3.1', '6.3.2', '6.4.1', '6.4.2', '6.5.1', '6.5.2', '6.6.1'];

          let chart1_labels_count = [0,0,0,0];
          let chart1_labels = [this.translation['yes'], this.translation['no'], this.translation['unknown'], this.translation['in development']];
          let chart1_labels_count_test = [];
          let chart2_labels_count = [0,0,0,0];
          let chart2_labels = [this.translation['yes'], this.translation['no'], this.translation['unknown'], this.translation['in development']];
          let chart2_labels_count_test = [];

          let chart3_labels_count = [0,0,0,0];
          let chart3_labels = [this.translation['yes'], this.translation['no'], this.translation['unknown'], this.translation['in development']];
          let chart3_labels_count_test = [];
          let chart4_labels_count = [0,0,0,0];
          let chart4_labels = [this.translation['yes'], this.translation['no'], this.translation['unknown'], this.translation['in development']];
          let chart4_labels_count_test = [];


          let chart5_labels_count = [0,0,0,0];
          let chart5_labels = [this.translation['yes'], this.translation['no'], this.translation['unknown'], this.translation['in development']];
          let chart5_labels_count_test = [];

          let chart6_labels_count = [0,0,0,0];
          let chart6_labels = [this.translation['yes'], this.translation['no'], this.translation['unknown'], this.translation['in development']];

          //go through each results elements
          for (i=0; i<res.length; i++){

            var r=res[i];
          // console.log('res',res[i]);
          if(r.question_type_name=='t4a'){
            console.log(r.sub_category,r.sub_category,r.value,r.question_category)
          }

         //  console.log(r.question_type_name=='t1a',r.sub_category,r.sub_category,r.value==='No',r.question_category);

           if (r.question_category==615 && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[0]=r.value_weight;;

              }
              if(r.value=="No"){
                chart1_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[0]=r.value_weight;;
               }

            }

            if (r.question_category==621  && res[i].question_type_name=='t1a' )
            {
             if(r.value=="Yes"){
              chart1_labels_count_test[1]=r.value_weight;

            }
            if(r.value=="No"){
              chart1_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="Unknown"){
              chart1_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="In development"){
              chart1_labels_count_test[1]=r.value_weight;
             }
            }

            if (r.question_category==627  && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[2]=r.value_weight;

              }
              if(r.value=="No"){
                chart1_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[2]=r.value_weight;
               }
            }

            if (r.question_category==633  && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[3]=r.value_weight;

              }
              if(r.value=="No"){
                chart1_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[3]=r.value_weight;
               }
            }
            if (r.question_category==639  && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[4]=r.value_weight;

              }
              if(r.value=="No"){
                chart1_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[4]=r.value_weight;
               }
            }
            if (r.question_category==645  && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[5]=r.value_weight;

              }
              if(r.value=="No"){
                chart1_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[5]=r.value_weight;
               }
            }

            if (r.question_category==651  && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[6]=r.value_weight;

              }
              if(r.value=="No"){
                chart1_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[6]=r.value_weight;
               }

            }

            if (r.question_category==657  && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[7]=r.value_weight;

              }
              if(r.value=="No"){
                chart1_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[7]=r.value_weight;
               }
            }

            if (r.question_category==663  && res[i].question_type_name=='t1a' )
            {
              if(r.value=="Yes"){
                chart1_labels_count_test[8]=r.value_weight;

              }
              if(r.value=="No"){
                chart1_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart1_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="In development"){
                chart1_labels_count_test[8]=r.value_weight;
               }
            }

            if (r.question_category==616 && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[0]=r.value_weight;;

              }
              if(r.value=="No"){
                chart2_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[0]=r.value_weight;;
               }

            }

            if (r.question_category==622  && res[i].question_type_name=='t2a' )
            {
             if(r.value=="Yes"){
              chart2_labels_count_test[1]=r.value_weight;

            }
            if(r.value=="No"){
              chart2_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="Unknown"){
              chart2_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="In development"){
              chart2_labels_count_test[1]=r.value_weight;
             }
            }

            if (r.question_category==628  && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[2]=r.value_weight;

              }
              if(r.value=="No"){
                chart2_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[2]=r.value_weight;
               }
            }

            if (r.question_category==634  && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[3]=r.value_weight;

              }
              if(r.value=="No"){
                chart2_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[3]=r.value_weight;
               }
            }
            if (r.question_category==640  && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[4]=r.value_weight;

              }
              if(r.value=="No"){
                chart2_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[4]=r.value_weight;
               }
            }
            if (r.question_category==646  && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[5]=r.value_weight;

              }
              if(r.value=="No"){
                chart2_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[5]=r.value_weight;
               }
            }

            if (r.question_category==652  && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[6]=r.value_weight;

              }
              if(r.value=="No"){
                chart2_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[6]=r.value_weight;
               }

            }

            if (r.question_category==658  && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[7]=r.value_weight;

              }
              if(r.value=="No"){
                chart2_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[7]=r.value_weight;
               }
            }

            if (r.question_category==664  && res[i].question_type_name=='t2a' )
            {
              if(r.value=="Yes"){
                chart2_labels_count_test[8]=r.value_weight;

              }
              if(r.value=="No"){
                chart2_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart2_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="In development"){
                chart2_labels_count_test[8]=r.value_weight;
               }
            }



            //t3a
            if (r.question_category==617 && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[0]=r.value_weight;;

              }
              if(r.value=="No"){
                chart3_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[0]=r.value_weight;;
               }

            }

            if (r.question_category==623  && res[i].question_type_name=='t3a' )
            {
             if(r.value=="Yes"){
              chart3_labels_count_test[1]=r.value_weight;

            }
            if(r.value=="No"){
              chart3_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="Unknown"){
              chart3_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="In development"){
              chart3_labels_count_test[1]=r.value_weight;
             }
            }

            if (r.question_category==629  && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[2]=r.value_weight;

              }
              if(r.value=="No"){
                chart3_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[2]=r.value_weight;
               }
            }

            if (r.question_category==635  && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[3]=r.value_weight;

              }
              if(r.value=="No"){
                chart3_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[3]=r.value_weight;
               }
            }
            if (r.question_category==641  && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[4]=r.value_weight;

              }
              if(r.value=="No"){
                chart3_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[4]=r.value_weight;
               }
            }
            if (r.question_category==647  && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[5]=r.value_weight;

              }
              if(r.value=="No"){
                chart3_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[5]=r.value_weight;
               }
            }

            if (r.question_category==653  && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[6]=r.value_weight;

              }
              if(r.value=="No"){
                chart3_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[6]=r.value_weight;
               }

            }

            if (r.question_category==659  && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[7]=r.value_weight;

              }
              if(r.value=="No"){
                chart3_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[7]=r.value_weight;
               }
            }

            if (r.question_category==665  && res[i].question_type_name=='t3a' )
            {
              if(r.value=="Yes"){
                chart3_labels_count_test[8]=r.value_weight;

              }
              if(r.value=="No"){
                chart3_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart3_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="In development"){
                chart3_labels_count_test[8]=r.value_weight;
               }
            }


            //  else  if (res[i].question_type_name=='t2a')
            // {
            //   if(res[i].value==="Yes"){

            //     chart2_labels_count_test.push(res[i]['value_weight']);


            //   }
            //   else if(res[i].value==="No"){
            //     chart2_labels_count_test.push(res[i]['value_weight']);

            //   }
            //   else if(res[i].value==="Unknown"){
            //     chart2_labels_count_test.push(res[i]['value_weight']);

            //   }
            //   else if(res[i].value==="In development"){
            //     chart2_labels_count_test.push(res[i]['value_weight']);

            //   }

            // }



            // else  if (res[i].question_type_name=='t3a')
            // {
            //   if(res[i].value==="Yes"){

            //     chart3_labels_count_test.push(res[i]['value_weight']);


            //   }
            //   else if(res[i].value==="No"){
            //     chart3_labels_count_test.push(res[i]['value_weight']);

            //   }
            //   else if(res[i].value==="Unknown"){
            //     chart3_labels_count_test.push(res[i]['value_weight']);

            //   }
            //   else if(res[i].value==="In development"){
            //     chart3_labels_count_test.push(res[i]['value_weight']);

            //   }

            // }

//t7a

if (r.question_category==737 && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[0]=r.value_weight;;

              }
              if(r.value=="No"){
                chart4_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="In Development"){
                chart4_labels_count_test[0]=r.value_weight;;
               }

            }

            if (r.question_category==738  && res[i].question_type_name=='t7a' )
            {
             if(r.value=="Yes"){
              chart4_labels_count_test[1]=r.value_weight;

            }
            if(r.value=="No"){
              chart4_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="Unknown"){
              chart4_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="In development"){
              chart4_labels_count_test[1]=r.value_weight;
             }
            }

            if (r.question_category==739  && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[2]=r.value_weight;

              }
              if(r.value=="No"){
                chart4_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="In development"){
                chart4_labels_count_test[2]=r.value_weight;
               }
            }

            if (r.question_category==740  && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[3]=r.value_weight;

              }
              if(r.value=="No"){
                chart4_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="In development"){
                chart4_labels_count_test[3]=r.value_weight;
               }
            }
            if (r.question_category==741  && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[4]=r.value_weight;

              }
              if(r.value=="No"){
                chart4_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="In development"){
                chart4_labels_count_test[4]=r.value_weight;
               }
            }
            if (r.question_category==742  && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[5]=r.value_weight;

              }
              if(r.value=="No"){
                chart4_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="In development"){
                chart4_labels_count_test[5]=r.value_weight;
               }
            }

            if (r.question_category==743  && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[6]=r.value_weight;

              }
              if(r.value=="No"){
                chart4_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="In development"){
                chart4_labels_count_test[6]=r.value_weight;
               }

            }

            if (r.question_category==744  && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[7]=r.value_weight;

              }
              if(r.value=="No"){
                chart4_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="In development"){
                chart4_labels_count_test[7]=r.value_weight;
               }
            }

            if (r.question_category==745  && res[i].question_type_name=='t7a' )
            {
              if(r.value=="Yes"){
                chart4_labels_count_test[8]=r.value_weight;

              }
              if(r.value=="No"){
                chart4_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart4_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="In development"){
                chart4_labels_count_test[8]=r.value_weight;
               }
            }

            // else  if (res[i].question_type_name=='t7a')
            // {
            //   if(res[i].value==="Yes"){
            //   chart4_labels_count_test.push(res[i]['value_weight']);
            //   }
            //   else if(res[i].value==="No"){
            //     chart4_labels_count_test.push(res[i]['value_weight']);
            //   }
            //   else if(res[i].value==="Unknown"){
            //     chart4_labels_count_test.push(res[i]['value_weight']);
            //   }
            //   else if(res[i].value==="In development"){
            //     chart4_labels_count_test.push(res[i]['value_weight']);

            //   }
            // }



              // if(res[i].question_type_name=='t4a' || res[i].question_type_name=='t4b' || res[i].question_type_name=='t4c'){
              //   var weight_index = res[i]['value_weight']-1;
              //   chart6_labels_count[weight_index]+=1;
              // }



            // else  if (res[i].question_type_name=='t4a')
            // {
            //   if(res[i].value==="Yes"){

            //     chart5_labels_count_test.push(res[i]['value_weight']);


            //   }
            //   else if(res[i].value==="No"){
            //     chart5_labels_count_test.push(res[i]['value_weight']);

            //   }
            //   else if(res[i].value==="Unknown"){
            //     chart5_labels_count_test.push(res[i]['value_weight']);

            //   }
            //   else if(res[i].value==="In development"){
            //     chart5_labels_count_test.push(res[i]['value_weight']);

            //   }
            // }



            if (r.question_category==618 && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[0]=r.value_weight;;

              }
              if(r.value=="No"){
                chart5_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[0]=r.value_weight;;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[0]=r.value_weight;;
               }

            }

            if (r.question_category==624  && res[i].question_type_name=='t4a' )
            {
             if(r.value=="Yes"){
              chart5_labels_count_test[1]=r.value_weight;

            }
            if(r.value=="No"){
              chart5_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="Unknown"){
              chart5_labels_count_test[1]=r.value_weight;
            }
            if(r.value=="In development"){
              chart5_labels_count_test[1]=r.value_weight;
             }
            }

            if (r.question_category==630  && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[2]=r.value_weight;

              }
              if(r.value=="No"){
                chart5_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[2]=r.value_weight;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[2]=r.value_weight;
               }
            }

            if (r.question_category==636  && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[3]=r.value_weight;

              }
              if(r.value=="No"){
                chart5_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[3]=r.value_weight;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[3]=r.value_weight;
               }
            }
            if (r.question_category==642  && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[4]=r.value_weight;

              }
              if(r.value=="No"){
                chart5_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[4]=r.value_weight;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[4]=r.value_weight;
               }
            }
            if (r.question_category==648  && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[5]=r.value_weight;

              }
              if(r.value=="No"){
                chart5_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[5]=r.value_weight;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[5]=r.value_weight;
               }
            }

            if (r.question_category==654  && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[6]=r.value_weight;

              }
              if(r.value=="No"){
                chart5_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[6]=r.value_weight;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[6]=r.value_weight;
               }

            }

            if (r.question_category==660  && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[7]=r.value_weight;

              }
              if(r.value=="No"){
                chart5_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[7]=r.value_weight;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[7]=r.value_weight;
               }
            }

            if (r.question_category==666  && res[i].question_type_name=='t4a' )
            {
              if(r.value=="Yes"){
                chart5_labels_count_test[8]=r.value_weight;

              }
              if(r.value=="No"){
                chart5_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="Unknown"){
                chart5_labels_count_test[8]=r.value_weight;
              }
              if(r.value=="In development"){
                chart5_labels_count_test[8]=r.value_weight;
               }
            }





          }
          //Calculation of Proportion using above array of values
          for (var i=0; i< this.subcat_index.length; i++){

            let avg_value_fp, avg_value_rp;
            //calculate proportion of response of formulation policy
            if (count_non_empty_fp[i]==count_3_5_fp[i]){
              avg_value_fp=0;
            }
            else {
              avg_value_fp = count_yes_fp[i]/(count_non_empty_fp[i]);
              avg_value_fp*=100;
            }
            formulation_policy[i]=avg_value_fp.toFixed(0);
            if (count_non_empty_rp[i]==count_3_5_rp[i]){
              avg_value_rp=0;
            }
            else {
              avg_value_rp = count_yes_rp[i]/(count_non_empty_rp[i]);
              avg_value_rp*=100;
            }
            regulatory_policy[i]=avg_value_rp.toFixed(0);
          }

            //convert this count array into percentage array to show in pie chart
          for (var i=0; i< equitable_access_count.length; i++)
          //[2,5,1,1]
          //4
            equitable_access_count[i]= +((equitable_access_count[i]/9)*100).toFixed(0);
            //2=+2/9*100


            //convert this count array into percentage array to show in pie chart
          for (var i=0; i< integrity_train_count.length; i++)
            integrity_train_count[i]= +((integrity_train_count[i]/9)*100).toFixed(0);

          for (var i=0; i< chart1_labels_count.length; i++)
            chart1_labels_count[i]= +Math.trunc((chart1_labels_count[i]/18)*100);

          for (var i=0; i< chart2_labels_count.length; i++)
            chart2_labels_count[i]= +Math.trunc((chart2_labels_count[i]/18)*100);

          for (var i=0; i< chart3_labels_count.length; i++)
            chart3_labels_count[i]= +Math.trunc((chart3_labels_count[i]/27)*100);

          for (var i=0; i< chart4_labels_count.length; i++)
            chart4_labels_count[i]= +Math.trunc((chart4_labels_count[i]/27)*100);

          for (var i=0; i< chart5_labels_count.length; i++)
            chart5_labels_count[i]= +Math.trunc((chart5_labels_count[i]/27)*100);

            for (var i=0; i< chart6_labels_count.length; i++)
            chart6_labels_count[i]= +Math.trunc((chart6_labels_count[i]/27)*100);

          var chart1_title = Object.assign({}, cc.chart_title);
            var chart2_title = Object.assign({}, cc.chart_title);
          var chart3_title = Object.assign({}, cc.chart_title);
          var chart4_title = Object.assign({}, cc.chart_title);
          var chart5_title = Object.assign({}, cc.chart_title);
          var chart6_title = Object.assign({}, cc.chart_title);

          chart1_title.text = [...this.translation['Mechanisms of accountability to prevent and detect']];
          chart2_title.text = [...this.translation['Fair and equitable access to the development and implementation']];
          chart3_title.text = [...this.translation['Regulatory processes are simple and transparent ']];
          chart4_title.text = [...this.translation['Anti-corruption action plans shared between government and ']];
          chart5_title.text = [...this.translation['Public financial management and procurement used to prevent']];

          // console.log('========',chart1_title.text);
          // console.log('========',chart2_title.text);
          // console.log('========',chart3_title.text);
          // console.log('========',chart4_title.text);
          // console.log('========',chart5_title.text);

          //translating the legends
          cc.scales_y_score_x_sdg6.xAxes[0].scaleLabel.labelString = this.translation[cc.scales_y_score_x_sdg6.xAxes[0].scaleLabel.labelString]

          let arr=[4,2,1,3];

          chart1_labels_count_test = chart1_labels_count_test.map(item=>arr[item-1]);
          this.chart1 = new Chart('canvas1', {
            type: 'polarArea',
            data:{

              labels:subcatlabels_small,
              datasets: [{
              //  datalabels : chart2_labels_test,
               labels : subcatlabels_small,
               type:'polarArea',
                data: chart1_labels_count_test,
                backgroundColor: chart1_labels_count_test.map(item => cc.polarArea_colors_col1[item-1])
              }],
            },
            options: {
              startAngle:4.8,

              plugins: {
                datalabels:{
                  display:false,
                },
                labels: {

                  render: 'label',
                  arc: false,
                  position: 'border',
                  fontSize: 12,
                 fontStyle: 'bold',
                fontColor: '#fff',
                }

                },


        scale: {

          ticks: {
            min:0,
            max:4,
            stepSize:1,
            maxTicksLimit: 9,
            display: false,
          },
          angleLines: {
            display: true,
           },

          pointLabels: {
            display: false,
            fontSize:14,

            margin:50
          },


        },

              tooltips:cc.polarchart_tooltips,

              // layout: cc.piechart_layout,
              layout:{
                padding:10
              },
              responsive: false,
              title : chart1_title,
              legend:{
                display:false
              },
            }

          });
//  console.log('chart1',chart1_labels_count_test);

          chart2_labels_count_test=chart2_labels_count_test.map(item=>arr[item-1]);
          this.chart2 = new Chart('canvas2', {
            type: 'polarArea',
            data:{

              labels:subcatlabels_small,
              datasets: [{
              //  datalabels : chart2_labels_test,
               labels : subcatlabels_small,
                data: chart2_labels_count_test,
                backgroundColor: chart2_labels_count_test.map(item => cc.polarArea_colors_col1[item-1])
              }],
            },
            options: {
              startAngle:4.8,

              plugins: {
                datalabels:{
                  display:false,
                },
                labels: {

                  render: 'label',
                  arc: false,
                  position: 'border',
                  fontSize: 12,
                 fontStyle: 'bold',
                fontColor: '#fff',
                }

                },


        scale: {

          ticks: {
            min:0,
            max:4,
            stepSize:1,
            maxTicksLimit: 9,
            display: false,
          },
          angleLines: {
            display: true,
           },

          pointLabels: {
            display: false,
            fontSize:14,

            margin:50
          },


        },

              tooltips:cc.polarchart_tooltips,

              // layout: cc.piechart_layout,
              layout:{
                padding:10
              },
              responsive: false,
              title : chart2_title,
              legend:{
                display:false
              },
            }
          });
          //  console.log('chart2',chart2_labels_count_test);

          chart3_labels_count_test = chart3_labels_count_test.map(item=>arr[item-1]);
          this.chart3 = new Chart('canvas3', {
            type: 'polarArea',
            data:{

              labels:subcatlabels_small,
              datasets: [{
              //  datalabels : chart2_labels_test,
               labels : subcatlabels_small,
                data: chart3_labels_count_test,
                backgroundColor: chart3_labels_count_test.map(item => cc.polarArea_colors_col1[item-1])
              }],
            },
            options: {
              startAngle:4.8,

              plugins: {
                datalabels:{
                  display:false,
                },
                labels: {

                  render: 'label',
                  arc: false,
                  position: 'border',
                  fontSize: 12,
                 fontStyle: 'bold',
                fontColor: '#fff',
                }

                },


        scale: {

          ticks: {
            min:0,
            max:4,
            stepSize:1,
            maxTicksLimit: 9,
            display: false,
          },
          angleLines: {
            display: true,
           },

          pointLabels: {
            display: false,
            fontSize:14,

            margin:50
          },


        },

              tooltips:cc.polarchart_tooltips,

              // layout: cc.piechart_layout,
              layout:{
                padding:10
              },
              responsive: false,
              title : chart3_title,
              legend:{
                display:false
              },
            }
          });
// console.log(chart3_labels_count_test,'chart3');

          chart4_labels_count_test=chart4_labels_count_test.map(item=>arr[item-1]);
          this.chart4 = new Chart('canvas4', {
            type: 'polarArea',
            data:{

              labels:subcatlabels_small,
              datasets: [{
              //  datalabels : chart2_labels_test,
               labels : subcatlabels_small,
                data: chart4_labels_count_test,
                backgroundColor: chart4_labels_count_test.map(item => cc.polarArea_colors_col1[item-1])
              }],
            },
            options: {
              startAngle:4.8,

              plugins: {
                datalabels:{
                  display:false,
                },
                labels: {

                  render: 'label',
                  arc: false,
                  position: 'border',
                  fontSize: 12,
                 fontStyle: 'bold',
                fontColor: '#fff',
                }

                },


        scale: {

          ticks: {
            min:0,
            max:4,
            stepSize:1,
            maxTicksLimit: 9,
            display: false,
          },
          angleLines: {
            display: true,
           },

          pointLabels: {
            display: false,
            fontSize:14,

            margin:50
          },


        },

              tooltips:cc.polarchart_tooltips,

              // layout: cc.piechart_layout,
              layout:{
                padding:10
              },
              responsive: false,
              title : chart4_title,
              legend:{
                display:false
              },
            }
          });
           console.log('chart4',chart4_labels_count_test);


          chart5_labels_count_test = chart5_labels_count_test.map(item=>arr[item-1]);
              this.chart5 = new Chart('canvas5', {
                type: 'polarArea',
                data:{

                  labels:subcatlabels_small,
                  datasets: [{
                  //  datalabels : chart2_labels_test,
                   labels : subcatlabels_small,
                    data: chart5_labels_count_test,
                    backgroundColor: chart5_labels_count_test.map(item => cc.polarArea_colors_col1[item-1])
                  }],
                },
                options: {
                  startAngle:4.8,

                  plugins: {
                    datalabels:{
                      display:false,
                    },
                    labels: {

                      render: 'label',
                      arc: false,
                      position: 'border',
                      fontSize: 12,
                     fontStyle: 'bold',
                    fontColor: '#fff',
                    }

                    },


            scale: {

              ticks: {
                min:0,
                max:4,
                stepSize:1,
                maxTicksLimit: 9,
                display: false,
              },
              angleLines: {
                display: true,
               },

              pointLabels: {
                display: false,
                fontSize:14,

                margin:50
              },


            },

                  tooltips:cc.polarchart_tooltips,

                  // layout: cc.piechart_layout,
                  layout:{
                    padding:10
                  },
                  responsive: false,
                  title : chart5_title,
                  legend:{
                    display:false
                  },
                }
              });
              //  console.log('chart5',chart5_labels_count_test);


               console.log(chart1_labels_count_test.length);
               console.log(chart2_labels_count_test.length);
               console.log(chart3_labels_count_test.length);
               console.log(chart4_labels_count_test.length);
               console.log(chart5_labels_count_test.length);

          setInterval(() => {
            this.loading = false;
            this.chRef.markForCheck();
          }, 2000);
        res = null;
        },error =>{
          this.alertService.error(error);
        });
        data = null;
},error => {
  this.alertService.error(error);
});
}

empty_objects(objects_arrays){
  for (var j=0; j<objects_arrays.length; j++){
    var props = Object.getOwnPropertyNames(objects_arrays[j]);
    for (var i = 0; i < props.length; i++) {
      delete objects_arrays[j][props[i]];
    }
  }
}

empty_array_of_arrays(arr_of_arr){
  for (var j=0; j<arr_of_arr.length; j++){
  arr_of_arr[j] = null;
  }
  arr_of_arr = null;
}

ngOnDestroy() {
  this.empty_array_of_arrays(this.subcategories);
  this.chart1 = null;
  this.chart2 = null;
  this.chart3 = null;
  this.chart4 = null;
  this.chart5 = null;

  this.subcat_index = null;

  if(this.subscription1)
    this.subscription1.unsubscribe();
  if(this.subscription2)
    this.subscription2.unsubscribe();
}

formatLabel(str, maxwidth){
  var sections = [];
  var words = str.split(" ");
  var temp = "";

  words.forEach(function(item, index){
    if(temp.length > 0)
    {
      var concat = temp + ' ' + item;

      if(concat.length > maxwidth){
        sections.push(temp);
        temp = "";
      }
      else{
        if(index == (words.length-1))
        {
          sections.push(concat);
          return;
        }
        else{
          temp = concat;
          return;
        }
      }
    }
    if(index == (words.length-1))
    {
      sections.push(item);
      return;
    }
    if(item.length < maxwidth) {
      temp = item;
    }
    else {
      sections.push(item);
    }
  });
  return sections;
}

  transparencyBtnClick(){
    this.router.navigateByUrl('/sdg/transparency')
  }
  quesBtnClick(){
      this.router.navigateByUrl('/sdg/transparency-quest')
  }
  dataBtnClick(){
      this.router.navigateByUrl('/sdg/transparency-data')
  }
  reportBtnClick(){
      this.router.navigateByUrl('/sdg/transparency-report')
  }

exportBtnClick(){

      let doc = new jsPDF('landscape');
      let canvas = document.getElementsByTagName('canvas');
      for(var i=0;i<canvas.length;i++){
        let height = (297 * canvas[i].height) / canvas[i].width;
        let y = (210 / 2) - (height / 2);
        if (this.lang == 5) {
          const legendpng = 'data:image/png;base64,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'
          doc.addImage(legendpng, "PNG", 240, 88, 40, 40);
          doc.addImage(canvas[i].toDataURL("image/png"), "PNG", 0, y, 297, height);
          const myFont = "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"; // load the *.ttf font file as binary string
          //  // add the font to jsPDF
          doc.addFileToVFS("NotoSansKR-Regular.ttf", myFont);
          doc.addFont("NotoSansKR-Regular.ttf", "NotoSansKR-Regular", "normal");
          doc.setFont('NotoSansKR-Regular', 'normal');
          doc.addImage(canvas[i].toDataURL("image/png"), "PNG", 0, y, 297, height);
        } else if (this.lang == 6) {
          const legendpng = 'data:image/png;base64,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'
          doc.addImage(legendpng, "PNG", 240, 88, 40, 40);
          doc.addImage(canvas[i].toDataURL("image/png"), "PNG", 0, y, 297, height);
          const myFont = "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"; // load the *.ttf font file as binary string
          //  // add the font to jsPDF
          doc.addFileToVFS("NotoSansKR-Regular.ttf", myFont);
          doc.addFont("NotoSansKR-Regular.ttf", "NotoSansKR-Regular", "normal");
          doc.setFont('NotoSansKR-Regular', 'normal');
          doc.addImage(canvas[i].toDataURL("image/png"), "PNG", 0, y, 297, height);
        }
        doc.setFillColor(35, 149, 97);  //green
        doc.addImage(canvas[i].toDataURL("image/png"), "PNG", 0, y, 297, height);
        doc.rect(230, 90, 6, 6, 'F');
        var ade=this.translation['Adequate'];
        doc.text(ade,240,95);
        doc.setFillColor(171, 217, 214);  //blue
        doc.rect(230, 100, 6, 6, 'F');
        var ind = this.translation['In development'];
        doc.text(ind, 240, 105);
        doc.setFillColor(203, 51, 31);   //red
        doc.rect(230, 110, 6, 6, 'F');
        var inad = this.translation['Inadequate'];
        doc.text(inad, 240, 115);
        doc.setFillColor(59, 61, 62);    //black
        doc.rect(230, 120, 6, 6, 'F');
        var unk = this.translation['Unknown/No Data'];
        doc.text(unk, 240, 125);
        if (i < (canvas.length - 1))
          doc.addPage();
      }
  doc.save('Transparency Report.pdf');
}
}



// WEBPACK FOOTER //
// ./src/app/sdg/transparency-report/transparency-report.component.ts